import { ShieldAlert, Users } from 'lucide-react'
import classNames from 'classnames'

import type { AlertOriginType } from '@/api/types/Alert'
import { formatAsTitle } from '@/utils/format'
import Flex from '@/elements/Flex'

import './Tag.scss'

interface TagProps {
  className?: string
  variant?: AlertOriginType
  children: string
  size?: 'normal' | 'large'
}

function Tag({
  className,
  variant,
  children,
  size = 'normal'
}: TagProps) {
  const renderIcon = () => {
    switch (variant) {
      case 'WATCHDOG':
        return <ShieldAlert size={18} />
      case 'PUBLIC_REPORT':
        return <Users size={18} />
      default:
        return null
    }
  }

  return (
    <Flex
      inline
      align='center'
      gap={1}
      className={
        classNames(
          'tag',
          { watchdog: variant === 'WATCHDOG', public: variant === 'PUBLIC_REPORT' },
          { 'normal-tag': size === 'normal', 'large-tag': size === 'large' },
          className
        )
      }>
      {renderIcon()}
      {formatAsTitle(children)}
    </Flex>
  )
}

export default Tag
